import { render, staticRenderFns } from "./ContaServico.vue?vue&type=template&id=906eae86&scoped=true"
import script from "./ContaServico.vue?vue&type=script&lang=js"
export * from "./ContaServico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906eae86",
  null
  
)

export default component.exports